import businessClient from 'src/services/clients/business'
import {
  // IServerNames,
  IMeta,
  IEmbargo,
} from 'src/common/interfaces/index.js'

const IResponse = { meta: IMeta, data: [IEmbargo] }

export const integrationEmbargo = {
  /**
   * @param {{ store_id: number,partner: string,embargo_venue_id: number }} data
   * @return {Promise<IResponse>}
   */
  pair(data, signal) {
    return businessClient().post('apppair/pair-data', { data }, { signal })
  },

  /**
   * @param {{store_id: number, auto_accept_minute: number }} data
   * @return {Promise<IResponse>}
   */
  autoAccept(data, signal) {
    return businessClient().post('apppair/embargo/auto-accept', { data }, { signal })
  },
}
